import { combineReducers } from 'redux'
import userDetailsReducer from './userDetailsReducer'
import transientReducer from './transientReducer'
import VehilceReducer from './vehicleReducer'
import PaymentReducer from './PaymentReducer'
import ReceiptsReducer from './ReceiptsReducer'
import singInAndSingUp from './singInAndSingUp'

export default combineReducers({
	userDetailsReducer,
	transientReducer,
	VehilceReducer,
	PaymentReducer,
	ReceiptsReducer,
	singInAndSingUp,
})
